import { z } from "zod"
import { SalesPaymentRefSchema } from "./SalesCommons"

export enum SalesPaymentMethod {
	CNP = "cnp",
}

export enum SalesPaymentStatus {
	Success = "SUCCESS",
	Failed = "FAILURE",
}

/**
 * S&O sales payment entity schema
 */
export const SalesPaymentModelSchema = z.object({
	id: z.string().min(1),
	payment_ref: SalesPaymentRefSchema,
	amount: z.number().min(0),
	method: z.enum([SalesPaymentMethod.CNP]),
	status: z.enum([SalesPaymentStatus.Failed, SalesPaymentStatus.Success]),
	created_at: z.string().datetime(),
})

export type SalesPaymentModel = z.infer<typeof SalesPaymentModelSchema>

export const CreateSalesPaymentModelSchema = SalesPaymentModelSchema.omit({ id: true, created_at: true }).extend({
	order_id: z.string().min(1),
	account_id: z.string().min(1),
})
export type CreateSalesPaymentModel = z.infer<typeof CreateSalesPaymentModelSchema>
